/**
 * Application entrypoint for the connect-with-claude test app (Story 301).
 *
 * Boots Vue 3, mounts the App shell, installs the router, and primes the
 * theme controller from `localStorage` before the first paint to prevent a
 * flash of the wrong theme.
 */
import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import { applyTheme, readStoredTheme } from './composables/useTheme';
import { resolveHashBootstrapRedirect } from './services/hashRouterBootstrap';
import './styles/tokens.css';
import './styles/theme.css';
import './styles/design-system.css';

// Apply persisted theme synchronously before mount to avoid FOUC.
applyTheme(readStoredTheme(globalThis.localStorage));

// GitLab's OAuth redirect lands with a real query string and an empty hash
// (Story 013.2) — send it into the hash-routed /callback path before the
// router's first navigation runs.
const bootstrapRedirect = resolveHashBootstrapRedirect(window.location);
if (bootstrapRedirect) {
  router.replace(bootstrapRedirect);
}

const app = createApp(App);
app.use(router);
app.mount('#app');
